// extracted by mini-css-extract-plugin
export var label = "_gk-2";
export var slideContainer = "_gk-0";
export var slider = "_gk-1";